export function getKey(id, model){
  return id ? `${model}-${id}` : model
}